import AddIcon from '@mui/icons-material/Add';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Button, Stack } from '@mui/material';

import { TableUtilityButtonGroupProps } from './props';

export const TableUtilityButtonGroup: React.FC<TableUtilityButtonGroupProps> = (
  props
) => {
  const {
    customLeftButton,
    customRightButton,
    LeftButtonProps,
    RightButtonProps,
    showLeftButton = true,
  } = props;
  // ======================= RENDER FUNCTIONS
  const renderLeftButton = () => {
    if (!showLeftButton) return null;

    return (
      customLeftButton ?? (
        <Button
          variant="outlined"
          startIcon={<FileUploadOutlinedIcon />}
          onClick={LeftButtonProps?.onClick}
        >
          {LeftButtonProps?.label ?? 'Export'}
        </Button>
      )
    );
  };

  // ======================= VIEWS
  return (
    <Stack
      direction="row"
      justifyContent={showLeftButton ? 'space-between' : 'flex-end'}
      padding={5}
    >
      {renderLeftButton()}
      {customRightButton ?? (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={RightButtonProps?.onClick}
        >
          {RightButtonProps?.label ?? 'Add'}
        </Button>
      )}
    </Stack>
  );
};

// ======================= EXPORT
export default TableUtilityButtonGroup;
